import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'

export function Card({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card"
      className={cn(
        'flex flex-col rounded-xl border border-border bg-card/95 p-6 sm:p-8 text-card-foreground',
        className,
      )}
      {...props}
    />
  )
}

export function CardHeader({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-header"
      className={cn('flex flex-col items-start gap-2', className)}
      {...props}
    />
  )
}

export function CardTitle({ className, ...props }: ComponentProps<'h1'>) {
  return (
    <h1
      data-slot="card-title"
      className={cn(
        'font-nb-architekt text-2xl leading-tight tracking-[0.04em] uppercase',
        className,
      )}
      {...props}
    />
  )
}

export function CardDescription({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-description"
      className={cn('text-sm leading-relaxed text-foreground/70', className)}
      {...props}
    />
  )
}

export function CardContent({ className, ...props }: ComponentProps<'div'>) {
  return <div data-slot="card-content" className={cn('mt-8', className)} {...props} />
}

export function CardFooter({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-footer"
      className={cn(
        'flex flex-wrap items-center gap-2 [&>div]:flex-wrap [&>div]:justify-center [&_a]:min-h-11 [&_a]:items-center [&_a]:rounded-sm [&_a]:underline-offset-4 [&_a:hover]:underline [&_a:focus-visible]:outline-2 [&_a:focus-visible]:outline-offset-4 [&_a:focus-visible]:outline-ring',
        className,
      )}
      {...props}
    />
  )
}
